import styles from "./Home.module.css";
import Header from "../../components/Header/Header";
import SideMenu from "../../components/SideMenu";
import TopMenu from "../../components/TopMenu";
import Main from "../../components/Main/Main";
import { AuthContext } from "../../Provider/AuthContext";
import { logout as exit, isAuthenticated } from "../../services/auth";
import Modal from "@mui/material/Modal";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalAtualizarSenha from "../../pages/AtualizarUsuario/ModalAtualizarSenha/ModalAtualizarSenha";

export default function Home() {
  const { logout, idTipoUsuario, idDepartamento, resetSenha, setResetSenha } =
    useContext(AuthContext);
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(true);

  const logged = isAuthenticated();
  if (logged === false) {
    navigate("/");
  }

  const idTipoMenu = localStorage.getItem("tipoMenu");
  console.log("menu " + idTipoMenu);

  const fullScreen = localStorage.getItem("fullscreen");
  console.log("fullscreen " + fullScreen);

  function leave() {
    exit();
    logout();
    navigate("/");
  }

  return (
    <>
      <Content
        idTipoMenu={idTipoMenu}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        leave={leave}
        fullScreen={fullScreen}
      />
      <Modal
        open={resetSenha}
        onClose={() => setResetSenha(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalAtualizarSenha
          setOpenModal={setResetSenha}
          closeModal={() => setResetSenha(false)}
        />
      </Modal>
    </>
  );
}

export function Content({
  idTipoMenu,
  showMenu,
  setShowMenu,
  leave,
  fullScreen,
}) {
  if (idTipoMenu == 1) {
    return (
      <div className={styles.container}>
        <Header onClick={() => setShowMenu(!showMenu)} color="1" />
        <section className={styles.content}>
          <div className={showMenu ? styles.closeMenu : styles.showMenu}>
            <SideMenu onClick={() => setShowMenu(!showMenu)} leave={leave} />
          </div>
          <Main />
        </section>
      </div>
    );
  }

  if (idTipoMenu == 2) {
    return (
      <div className={styles.container} id="home">
        <Header onClick={() => setShowMenu(!showMenu)} color="0" />
        <TopMenu leave={leave} />
        <Main fullWidth={fullScreen == 1} />
      </div>
    );
  }

  return null;
}
